import image2 from '../../assets/events/japanese_visit.jpeg'
import image4 from '../../assets/events/astronauts.webp'
import image5 from '../../assets/events/youth-ideathon.jpg'
import image6 from '../../assets/events/sts.webp'

const all_events = [
    {
        "image": image5,
        "title": "Youth Ideathon",
        "date": "April, 2025",
        "venue": "IIT Delhi, Abu Dhabi Campus",
        "past": false
    },
    {
        "image": image6,
        "title": "STS Spins Lecture",
        "date": "April, 2025",
        "venue": "IIT Delhi, Hauz Khas",
        "past": false
    },
    {
        "image": image4,
        "title": "Visit of Astronauts",
        "date": "May, 2025",
        "venue": "IIT Delhi, Hauz Khas",
        "past": false
    },
]

export default all_events;